import { cx } from './cx.ts'

import './progress.css'

/**
 * 분할 막대 — 와이어프레임 `progSplit()` 1009행 · `.pbar`/`.plbl` 856–861행.
 * 모니터링 사이드 패널 「진행」이 쓴다. 완료 · 진행 중 · 대기처럼 **개수**를 나눠 보여준다.
 *
 * 세 채움 단계는 토큰으로 갈린다(`--color-progress-done|estimate|track`).
 * 색만으로 구분되지 않게 라벨과 값이 항상 같이 나온다.
 */
export type SplitSegment = {
  key: string
  /** 화면 표기(한글) */
  label: string
  /** 값. 폭 비율이자 라벨에 그대로 찍힌다 */
  value: number
  /** 채움 단계. 없으면 빈 칸(대기) */
  tone?: 'done' | 'current' | undefined
}

export type SplitBarProps = {
  segments: readonly SplitSegment[]
  /** 접근성 이름 */
  label: string
}

/** 와이어프레임 `w()` 와 같다 — 0 인 구간도 최소 12% 는 보인다 */
const MIN_WIDTH_PERCENT = 12

export function SplitBar({ segments, label }: SplitBarProps) {
  const total = segments.reduce((sum, s) => sum + Math.max(0, s.value), 0) || 1
  const width = (value: number): string =>
    `${Math.max(MIN_WIDTH_PERCENT, (Math.max(0, value) / total) * 100).toFixed(1)}%`

  return (
    <div aria-label={label} className="a-split" role="group">
      <div aria-hidden="true" className="a-split__track">
        {segments.map((seg) => (
          <span
            className={cx(
              'a-split__seg',
              seg.tone === 'done' && 'a-split__seg--done',
              seg.tone === 'current' && 'a-split__seg--current',
            )}
            key={seg.key}
            style={{ width: width(seg.value) }}
          />
        ))}
      </div>
      <div className="a-split__labels">
        {segments.map((seg) => (
          <span className="a-split__label" key={seg.key} style={{ width: width(seg.value) }}>
            <b className="a-split__value">{seg.value}</b>
            {seg.label}
          </span>
        ))}
      </div>
    </div>
  )
}
